import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { errorMessage } from "@/lib/api";
import { inboxAiRetryEligible, retryInboxAiBatch, type InboxItem } from "@/lib/documentInbox";

export function InboxAiRetryButton({ items, disabled, onBusy, onComplete }: {
  items: InboxItem[]; disabled: boolean; onBusy: (busy: boolean) => void; onComplete: () => void;
}) {
  const running = useRef(false); const [busy, setBusy] = useState(false); const [notice, setNotice] = useState("");
  const eligible = items.filter(inboxAiRetryEligible);
  const reason = disabled || busy ? "Pričekajte završetak obrade." : !eligible.length ? "Odaberite dokument radnika ili nerazvrstani dokument iz uvoza paketa koji nije u obradi." : undefined;
  async function retry() {
    if (running.current || reason) return;
    running.current = true; setBusy(true); onBusy(true); setNotice("");
    let queued = 0; const errors: string[] = [];
    try {
      for (let offset = 0; offset < eligible.length; offset += 200) {
        try { queued += (await retryInboxAiBatch(eligible.slice(offset, offset + 200).map(item => item.id))).queued; }
        catch (cause) { errors.push(errorMessage(cause, "AI obrada dijela odabira nije pokrenuta.")); }
      }
      setNotice(`U AI red stavljeno: ${queued}. ${errors.join(" ")}`); if (queued) onComplete();
    } finally { running.current = false; setBusy(false); onBusy(false); }
  }
  return <><span title={reason}><Button type="button" variant="outline" disabled={!!reason} onClick={() => void retry()}>AI ponovno</Button></span>{notice && <p role="status">{notice}</p>}</>;
}
